// import { useNotification } from "context/NotificationContext";
// import { useEffect } from "react";
// import socket from "services/SocketService";


// const SocketProvider = ({ children }) => {
//     const { showNotification } = useNotification();

//     const adminInfo = JSON.parse(localStorage.getItem("adminInfo") || "null");

//     const userId = adminInfo?.id;
//     const userName = adminInfo?.company_name;
//     const receiverType = 4;

//     useEffect(() => {
//         if (!userId || !userName) return;

//         const handleConnect = () => {
//             console.log("✅ Socket Connected");

//             socket.emit("register", [
//                 userId,
//                 userName,
//                 receiverType,
//             ]);
//         };

//         const handleReceiveNotification = (data) => {
//             showNotification(data);
//         };

//         socket.connect();

//         socket.on("connect", handleConnect);

//         socket.on(
//             "receiveNotification",
//             handleReceiveNotification
//         );

//         return () => {
//             socket.off("connect", handleConnect);

//             socket.off(
//                 "receiveNotification",
//                 handleReceiveNotification
//             );

//             socket.disconnect();
//         };
//     }, [userId, userName, showNotification]);

//     return children;
// };

// export default SocketProvider;



import { useContext, useEffect } from "react";

import { AdminContext } from "context/AdminContext";
import { useNotification } from "context/NotificationContext";
import socket from "services/SocketService";

const SocketProvider = ({ children }) => {
  const { showNotification } = useNotification();
  // Reading AdminContext (not localStorage directly) so this effect actually
  // re-runs the instant login/logout happens — login is a client-side route
  // change (history.replace), not a page reload, so a one-time localStorage
  // read here would permanently miss the admin that just logged in.
  const { state } = useContext(AdminContext);
  const adminInfo = state?.adminInfo;

  useEffect(() => {
    const userId = adminInfo?.id;
    const userName = adminInfo?.firstname || adminInfo?.company_name;
    const receiverType = 2;

    if (!userId || !userName) {
      console.warn("[socket] NOT CONNECTING: missing adminInfo.id or adminInfo.name (not logged in yet)", adminInfo);
      return;
    }
    const handleConnect = () => {
      console.log(`[socket] CONNECTED: socket.id=${socket.id}, url=${process.env.REACT_APP_API_SOCKET_URL}`);
      console.log(`[socket] REGISTERING as admin panel: userId=${userId}, userName=${userName}, receiverType=${receiverType}`);

      socket.emit("register", [
        userId,
        userName,
        receiverType,
      ]);
    };

    const handleDisconnect = (reason) => {
      console.warn("[socket] DISCONNECTED:", reason);
    };

    const handleError = (error) => {
      console.error("[socket] CONNECT_ERROR:", error.message, "- check REACT_APP_API_SOCKET_URL:", process.env.REACT_APP_API_SOCKET_URL);
    };

    const handleReceiveNotification = (data) => {
      showNotification(data);
    };

    if (!socket.connected) {
      socket.connect();
    }

    socket.on("connect", handleConnect);

    socket.on(
      "disconnect",
      handleDisconnect
    );

    socket.on(
      "connect_error",
      handleError
    );

    socket.on(
      "receiveNotification",
      handleReceiveNotification
    );

    return () => {
      socket.off(
        "connect",
        handleConnect
      );

      socket.off(
        "disconnect",
        handleDisconnect
      );

      socket.off(
        "connect_error",
        handleError
      );

      socket.off(
        "receiveNotification",
        handleReceiveNotification
      );

      socket.disconnect();
    };
  }, [adminInfo, showNotification]);

  return children;
};

export default SocketProvider;